import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import './i18n';
import { Amplify } from 'aws-amplify';
import { addRxPlugin } from 'rxdb/plugins/core';
import { RxDBDevModePlugin } from 'rxdb/plugins/dev-mode';
import { RxDBQueryBuilderPlugin } from 'rxdb/plugins/query-builder';
// import * as serviceWorker from './serviceWorker';

addRxPlugin(RxDBDevModePlugin);
addRxPlugin(RxDBQueryBuilderPlugin);


Amplify.configure({
  API: {
    GraphQL: {
      region: process.env[`REACT_APP_REGION_${process.env.REACT_APP_ENV}`],
      endpoint: process.env[`REACT_APP_ENDPOINT_AMPLIFY_${process.env.REACT_APP_ENV}`],
    }
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
